import { useState, useRef } from 'react'
import { Steps } from 'antd'
import classNames from 'classnames'

import _map from 'lodash/map'

import Title from 'components/Title'
import Image from 'components/Image'
import Carousel from 'components/Carousel'

import Styled from './styled'

export default function SectionWorkStep({ data }) {
  const [currentStep, setCurrentStep] = useState(0)

  const carouselRef = useRef(null)

  const title = data?.title
  const contents = data?.contents
  const stepItems = _map(contents, (item, index) => ({
    title: item?.title,
    onClick: () => {
      setCurrentStep(index)
      carouselRef.current?.swiper?.slideTo(index)
    },
  }))

  return (
    <Styled>
      <div className="left-block">
        <div className="work-step-content">
          <div className="title-block">
            <Title level={2}>{title}</Title>
          </div>

          <Steps progressDot current={currentStep} direction="vertical" items={stepItems} />
        </div>
      </div>

      <div className="right-block">
        <div className="title-block">
          <Title level={2}>{title}</Title>
        </div>

        <div className="circle">
          <Carousel
            innerRef={carouselRef}
            options={{
              autoplay: {
                delay: 8000,
              },
              slidesPerView: 1,
              pagination: false,
              onSlideChange: swiper => {
                setCurrentStep(swiper.activeIndex)
              },
            }}
            items={contents}
            uiRenderer={(item, index) => {
              const image = item?.image?.url
              const isActive = index === currentStep

              return (
                <div className={classNames('image-block', { active: isActive })} key={index}>
                  <Image src={image} />
                </div>
              )
            }}
          />
        </div>
      </div>
    </Styled>
  )
}
